import * as yup from 'yup';
import { FULL_NAME_MESSAGE, fullNameTest } from './fullName';

export const initialValues = {
	fullname: '',
	cpf: '',
	phone: [''],
	email: '',
	birthdate: '',
	gender: '',
	genderOther: '',
	mainDisabilityType: '',
};

const schema = 
	yup.object().shape({
		fullname: yup.string().required('Nome é obrigatório!').test('fullname', FULL_NAME_MESSAGE, fullNameTest),
		phone: yup
			.array()
			.min(1, 'Telefone é obrigatório!')
			.of(
				yup
					.string()
					.notRequired()
					.matches(/([0-9]{4,5}-[0-9]{4})/, { message: 'Telefone inválido!', excludeEmptyString: true }),
			)
			.test('testEmpty', 'Telefone é obrigatório!', val => {
				let hasOneValid = false;
				if (val.length > 0) {
					val.forEach(phone => {
						if (phone != null && !['', '(__) ____-____', '(__) _____-____'].includes(phone)) {
							hasOneValid = true;
						}
					});
				}
				return hasOneValid;
			}),
		email: yup
			.string()
			.email('Email deve ter um formato válido!')
			.required('Email é obrigatório!'),
		birthdate: yup.string().matches(/([0-9]{2}\/[0-9]{2}\/[0-9]{4})/, {message:'Data de nascimento é obrigatória!', excludeEmptyString:true}).required('Data de nascimento é obrigatória!'),
		gender: yup.string().required('Gênero é obrigatório!'),
		genderOther: yup.string(),
		mainDisabilityType: yup.string().required('Tipo de deficiência é obrigatório!'),
	});

export default schema;
